import {Box, Modal, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import storage from "../../services/storage";
import CloseIcon from "@mui/icons-material/Close";

import "./index.css";
import PoliticaPrivacidade from ".";
export default function BarraPolitica() {
  const [fechaBarraPolitica, setFechaBarraPolitica] = useState(true);
  const [tipoModal, setTipoModal] = useState(0);
  useEffect(() => {
    if (storage.get("POLITICA") == null) {
      storage.set("POLITICA", "false");
    }
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {fechaBarraPolitica && (
        <div className="barraPolitica">
          <div className="row d-flex align-items-center">
            <div className="col-md-9">
              <div>
                Nesta plataforma do Amigo Leo, não utilizamos cookies. Ao utilizar nosso website
              </div>
              <div>
                você concorda com a nossa <u className="pointer" onClick={()=>setTipoModal(1)}>Política de Privacidade</u>
              </div>
            </div>

            <div className=" col-md-3 d-flex align-items-center">
              <button
                className="btn btn-warning col-1"
                onClick={() => {
                  setFechaBarraPolitica(false);
                  storage.set("POLITICA", "true");
                }}>
                ENTENDI
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal
 
        keepMounted
        open={tipoModal != 0}
        onClose={() => setTipoModal(0)}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description">
        <Box className="configModal" style={{height:'80%', overflowY:'scroll', width:'80%'}}>
          <div className="d-flex justify-content-end pointer">
            <CloseIcon onClick={() => setTipoModal(0)} />
          </div>
 
              <PoliticaPrivacidade/>
         
        </Box>
      </Modal>
    </>
  );
}
